module.exports = __webpack_public_path__ + "img/img3-1.422d4cc4.png";